import React, { ReactNode } from "react";
import WebsiteLayout from "../layouts/WebsiteLayout/WebsiteLayout";
import AuthLayout from "../layouts/AuthLayout/AuthLayout";
import BlankLayout from "../layouts/BlankLayout/BlankLayout";
//FIXME - Need to add in types
type LayoutType = "Website" | "Auth" | "Blank";
//FIXME - Need to add in types
interface LayoutComponentProps {
  layoutType: LayoutType | String;
  children: ReactNode | ReactNode[];
}

const LayoutComponent: React.FC<LayoutComponentProps> = ({ layoutType, children }: any) => {
  const getLayoutComponent = (layoutType: LayoutType) => {
    switch (layoutType) {
      case "Website":
        return WebsiteLayout;
      case "Auth":
        return AuthLayout;
      case "Blank":
        return BlankLayout;
      default:
        return WebsiteLayout; // Default layout if no matching layoutType is found
    }
  };

  const Layout = getLayoutComponent(layoutType);

  return <Layout>{children}</Layout>;
};

export default LayoutComponent;
